import { UserPlus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * The bulk-selection action that opens `AssignServicesToTeamDialog`. One
 * component so the desktop and mobile services pages cannot drift on the
 * icon or the accessible name.
 *
 * On a phone it is a pill reading "Assign", to sit in the mobile selection
 * row beside Delete and Clear; the accessible name stays "Assign to team".
 */
export function AssignServicesToTeamButton({
  onClick,
  disabled,
  variant = 'desktop',
}: {
  onClick: () => void;
  disabled?: boolean;
  variant?: 'desktop' | 'mobile';
}) {
  const mobile = variant === 'mobile';
  return (
    <Button
      aria-label="Assign to team"
      className={cn(mobile && 'h-9 rounded-full border-[#E5E5EA] px-3')}
      disabled={disabled}
      onClick={onClick}
      size="sm"
      variant="outline"
    >
      <UserPlus className="size-4" />
      {mobile ? 'Assign' : 'Assign to team'}
    </Button>
  );
}
